import React, { useState, useEffect } from "react";
import { t } from "i18next";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { Button, Col, Result, Row, Spin } from "common/elements";
import { getPayslipById, getFinalPaymentById } from "services/payroll";
import "./payslip.css";
import { Util } from "common/util";
import Enum from "common/enums";
// import { Util } from "common/util";

const ViewPayslip = () => {
  const [payslip, setPayslip] = useState({
    employee: {},
    netPay: 0,
    payrollEntries: [],
    netPayEntries: [],
  });
  const [loading, setLoading] = useState(false);
  const [notFoundResult, setNotFoundResult] = useState(false);
  const params = new URLSearchParams(document.location.search);

  const navigate = useNavigate();
  const { id } = useParams();

  // eslint-disable-next-line
  const isProceedFinalPay = params.get("isProceedFinalPay") == 1;

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `@media print {
         @page {
            margin: 5px
         }

         .ant-layout-header {
            display: none !important
         }

         #main-content-layout {
            margin: 0px !important
         }

         .scroll {
            height: auto;
            padding: 0
         }
      }`;

    document.head.appendChild(style);

    setLoading(true);
    let promise = null;

    if (isProceedFinalPay) {
      promise = getFinalPaymentById(id);
    } else {
      promise = getPayslipById(id);
    }

    promise
      .then((response) => {
        if (response.data) {
          let { payrollEntries } = response.data;
          const foundFirstPaymentAt = payrollEntries.findIndex(
            (payrollEntry) => payrollEntry.payrollItemCode === "first_payment"
          );
          const netPayEntries = payrollEntries.slice(foundFirstPaymentAt);
          payrollEntries = payrollEntries.slice(0, foundFirstPaymentAt);

          setPayslip(() => ({
            ...response.data,
            payrollEntries,
            netPayEntries,
          }));
        }
      })
      .catch((error) => {
        if (error.response.status === 404) {
          setNotFoundResult(true);
        }
      })
      .finally(() => setLoading(false));

    // eslint-disable-next-line
  }, []);

  const onBack = () => {
    navigate("/payrolls");
  };

  const onPrint = () => {
    window.print();
  };

  if (loading) return <Spin spinning={loading} className="loading-view" />;

  return notFoundResult ? (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button type="primary" onClick={onBack}>
          Back
        </Button>
      }
    />
  ) : (
    <>
      <div className="btn-navigation" id="non-printable">
        <Row>
          <Col span={12}>
            <div className="pull-left">
              <Button onClick={onBack}>
                <ArrowLeftOutlined />
                {t("text_back")}
              </Button>
              <span className="title">
                {isProceedFinalPay ? "Final Payment" : "Payslip"}
              </span>
            </div>
          </Col>
          <Col span={12}>
            <div className="pull-right">
              <Button type="primary" onClick={onPrint}>
                <PrinterOutlined />
                {t("text_print")}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      {isProceedFinalPay ? (
        <FinalPay payslip={payslip} />
      ) : (
        <Payslip payslip={payslip} />
      )}
    </>
  );
};

const isDeductionAmount = (payrollEntry) => {
  return [
    Enum.PAYROLL_ITEM_TYPE.DEDUCTION,
    Enum.PAYROLL_ITEM_TYPE.TAXABLE_DEDUCTION,
    Enum.PAYROLL_ITEM_TYPE.PENSION_FUND,
  ].includes(payrollEntry.type);
};

function Payslip({ payslip }) {
  const payrollElement = (payrollEntry, index) => {
    let payrollEntryRow = (
      <tr key={index}>
        <td className="width-colcumns sub-title" colSpan={2}>
           {payrollEntry.code === "spouse" ? `${payrollEntry.title} And Child` : payrollEntry.title}
        </td>
        {isDeductionAmount(payrollEntry) ? (
          <td
            className="width-columns-setion-2"
            style={{ textAlign: "right", color: "red" }}
          >
            ({payrollEntry.code === "spouse" ? payrollEntry.amount :  Util.getInstance().formatCurrency(payrollEntry.amount, "$")})
          </td>
        ) : (
          <td className="width-columns-setion-2" style={{ textAlign: "right" }}>
            {payrollEntry.code === "spouse" ? payrollEntry.amount :  Util.getInstance().formatCurrency(payrollEntry.amount, "$")}
          </td>
        )}
      </tr>
    );

    if (payrollEntry.code === "total_spouse_kid") {
      payrollEntryRow = <></>;
    }

    if (payrollEntry.code === "gross_salary") {
      payrollEntryRow = (
        <tr className="text-total-netpay">
          <td className="width-colcumns sub-title" colSpan={2}>
            {payrollEntry.title}
          </td>
          {isDeductionAmount(payrollEntry) ? (
            <td
              className="width-columns-setion-2"
              style={{ textAlign: "right", color: "red" }}
            >
              ({Util.getInstance().formatCurrency(payrollEntry.amount, "$")})
            </td>
          ) : (
            <td
              className="width-columns-setion-2"
              style={{ textAlign: "right" }}
            >
              {Util.getInstance().formatCurrency(payrollEntry.amount, "$")}
            </td>
          )}
        </tr>
      );
    }

    return payrollEntryRow;
  };

  return (
    <div className="display-table-view scroll" id="payslip">
      <section className="section-header">
        <div className="header-title">
          <img src="/logo.png" alt="logo" />
          <div className="title-info">
            <h3>Norwegain People's Aid</h3>
            <h5>Cambodia</h5>
          </div>
        </div>
      </section>
      <div className="date-payslip">
        <h2 style={{ fontWeight: "bold" }}>MONTHLY PAYSLIP</h2>
        <div>
          For{" "}
          <span>{`${
            payslip.month &&
            (payslip.month.toString().length === 1
              ? moment(`1970-0${payslip.month}-01`).format("MMMM")
              : moment(`1970-${payslip.month}-01`).format("MMMM"))
          } ${payslip.year && payslip.year}`}</span>
        </div>
      </div>

      <section className="section-table">
        <table id="table1">
          <thead>
            <tr>
              <th colSpan={3} className="bg-header-table">
                <span className="title">EMPLOYEE’S INFORMATION:</span>
              </th>
            </tr>
          </thead>
          <tbody className="setion-1">
            <tr>
              <td className="width-colcumns sub-title">Name of Staff</td>
              <td colSpan={2} className="text-color-name">
                {payslip?.employeeName}
              </td>
            </tr>
            <tr>
              <td className="width-colcumns sub-title">Position Title</td>
              <td colSpan={2}>{payslip?.position}</td>
            </tr>
            <tr>
              <td className="width-colcumns sub-title">Bank Account:</td>
              <td colSpan={2}>{payslip?.bankAccNumber}</td>
            </tr>
            <tr>
              <td className="width-colcumns sub-title">No. of dependent</td>
              <td colSpan={2}>{payslip?.numberOfdependent}</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan={3} className="bg-header-table">
                <span className="title">PAYROLL INFORMATION:</span>
              </th>
            </tr>
          </thead>
          <tbody className="setion-2">
            <tr>
              <td className="width-colcumns sub-title" colSpan={2}>
                Basic Salary
              </td>
              <td
                className="width-columns-setion-2"
                style={{ textAlign: "right" }}
              >
                {Util.getInstance().formatCurrency(payslip.basicSalary, "$")}
              </td>
            </tr>
            {payslip.payrollEntries.map((payrollEntry, index) =>
              payrollElement(payrollEntry, index)
            )}
            <tr className="text-total-netpay">
              <td className="width-colcumns sub-title" colSpan={2}>
                TOTAL NET PAYMENT
              </td>
              <td
                className="width-columns-setion-2"
                style={{ textAlign: "right" }}
              >
                {Util.getInstance().formatCurrency(payslip.netPay, "$")}
              </td>
            </tr>
            {payslip.netPayEntries.map((payrollEntry, index) =>
              payrollElement(payrollEntry, index)
            )}
          </tbody>
        </table>
        <table id="table2">
          <tbody>
            <tr>
              <td className="header-text-Italic">Acknowledgment of Staff:</td>
            </tr>
            <tr>
              <td className="text-grey" style={{ fontWeight: "normal" }}>
                I hereby acknowledge the receipt of the total net pay of{" "}
                <strong style={{ color: "black" }}>
                  US {Util.getInstance().formatCurrency(payslip.netPay)}
                </strong>{" "}
                which got deposited to my ABA bank account, as stated above. If
                I come across any error in this pays lip, instantly contact HRD
                unit.
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="footer">
        <div className="section-footer">
          <ul className="sec-1">
            <li>
              Phnom Penh Office #4, St. 278, Sangkat Olympic, P.O.Box 2228,Phnom
              Penh, Cambodia.
            </li>
            <li>
              Phone : <span>855-23 210 383, 855-23 218 197</span>
            </li>
            <li>
              Mobile : <span>855-12 800 103, 855-12 817 217</span>
            </li>
          </ul>
          <ul className="sec-2">
            <li>
              Phnom Penh Office #4, St. 278, Sangkat Olympic, P.O.Box 2228,Phnom
              Penh, Cambodia.
            </li>
            <li>
              Phone : <span>855-23 210 383, 855-23 218 197</span>
            </li>
            <li>
              Mobile : <span>855-12 800 103, 855-12 817 217</span>
            </li>
          </ul>
          <ul className="sec-3">
            <li>
              Phnom Penh Office #4, St. 278, Sangkat Olympic, P.O.Box 2228,Phnom
              Penh, Cambodia.
            </li>
            <li>
              Phone : <span>855-23 210 383, 855-23 218 197</span>
            </li>
            <li>
              Mobile : <span>855-12 800 103, 855-12 817 217</span>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}

function FinalPay({ payslip }) {
  const payrollElement = (payrollEntry, index) => {
    let payrollEntryRow = (
      <tr key={index}>  
        <td className="width-colcumns sub-title">{payrollEntry.payrollItemCode === "spouse" ? `${payrollEntry.title} And Child` : payrollEntry.title}</td>
        {isDeductionAmount(payrollEntry) ? (
          <td
            className="width-columns-setion-2"
            style={{ textAlign: "right", color: "red" }}
          >
            ({payrollEntry.payrollItemCode === "spouse" ? payrollEntry.amount : Util.getInstance().formatCurrency(payrollEntry.amount, "$")})
          </td>
        ) : (
          <td className="width-columns-setion-2" style={{ textAlign: "right" }}>
            {payrollEntry.payrollItemCode === "spouse" ? payrollEntry.amount : Util.getInstance().formatCurrency(payrollEntry.amount, "$")}
          </td>
        )}
        <td className="width-columns-setion-2">{payrollEntry?.remark}</td>
      </tr>
    );
    if (payrollEntry.payrollItemCode === "total_spouse_kid") {
      payrollEntryRow = <></>;
    }

    if (payrollEntry.payrollItemCode === "gross_salary") {
      payrollEntryRow = (
        <tr className="text-total-netpay">
          <td className="width-colcumns sub-title">{payrollEntry.title}</td>
          {isDeductionAmount(payrollEntry) ? (
            <td
              className="width-columns-setion-2"
              style={{ textAlign: "right", color: "red" }}
            >
              ({Util.getInstance().formatCurrency(payrollEntry.amount, "$")})
            </td>
          ) : (
            <td
              className="width-columns-setion-2"
              style={{ textAlign: "right" }}
            >
              {Util.getInstance().formatCurrency(payrollEntry.amount, "$")}
            </td>
          )}
          <td className="width-columns-setion-2">{payrollEntry?.remark}</td>
        </tr>
      );
    }

    return payrollEntryRow;
  };

  return (
    <div className="display-table-view scroll" id="payslip">
      <section className="section-header">
        <div className="header-title">
          <img src="/logo.png" alt="logo" />
          <div className="title-info">
            <h3>Norwegain People's Aid</h3>
            <h5>Cambodia</h5>
          </div>
        </div>
      </section>
      <div className="date-payslip">
        <h2 style={{ marginBottom: 0, fontWeight: "bold" }}>FINAL PAYMENT</h2>
        <div>
          For{" "}
          <span>{`${
            payslip.month &&
            (payslip.month.toString().length === 1
              ? moment(`1970-0${payslip.month}-01`).format("MMMM")
              : moment(`1970-${payslip.month}-01`).format("MMMM"))
          } ${payslip.year && payslip.year}`}</span>
        </div>
      </div>

      <section className="section-table" style={{ marginTop: 25 }}>
        <table id="table1">
          <thead>
            <tr>
              <th colSpan={3} className="bg-header-table">
                <span className="title">EMPLOYEE’S INFORMATION:</span>
              </th>
            </tr>
          </thead>
          <tbody className="setion-1">
            <tr>
              <td className="sub-title">Name of Staff</td>
              <td colSpan={2} className="text-color-name">
                {payslip?.employeeName}
              </td>
            </tr>
            <tr>
              <td className="sub-title">Position Title</td>
              <td colSpan={2}>{payslip?.position}</td>
            </tr>
            <tr>
              <td className="width-colcumns sub-title">Bank Account:</td>
              <td colSpan={2}>{payslip?.bankAccNumber}</td>
            </tr>
            <tr>
              <td className="width-colcumns sub-title">No. of dependent</td>
              <td colSpan={2}>{payslip?.numberOfdependent}</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th className="bg-header-table">
                <span className="title">PAYROLL INFORMATION:</span>
              </th>
              <th className="bg-header-table">
                <span className="title">AMOUNT:</span>
              </th>
              <th className="bg-header-table">
                <span className="title">REMARK:</span>
              </th>
            </tr>
          </thead>
          <tbody className="setion-2">
            <tr>
              <td className="width-colcumns sub-title">Basic Salary</td>
              <td
                className="width-columns-setion-2"
                style={{ textAlign: "right" }}
              >
                {Util.getInstance().formatCurrency(payslip.basicSalary, "$")}
              </td>
              <td className="width-columns-setion-2"></td>
            </tr>
            {payslip.payrollEntries.map((payrollEntry, index) =>
              payrollElement(payrollEntry, index)
            )}
            <tr className="text-total-netpay">
              <td className="width-colcumns sub-title">TOTAL NET PAYMENT</td>
              <td
                className="width-columns-setion-2"
                style={{ textAlign: "right" }}
              >
                {Util.getInstance().formatCurrency(payslip.netPay, "$")}
              </td>
              <td className="width-columns-setion-2"></td>
            </tr>
            {payslip.netPayEntries.map((payrollEntry, index) =>
              payrollElement(payrollEntry, index)
            )}
          </tbody>
        </table>
        <table id="table2">
          <tbody>
            <tr>
              <td style={{ border: "none" }}>
                <div style={{ marginTop: 25 }}>Signatures: ហត្ថលេខា</div>
                <div
                  style={{
                    width: 250,
                    borderBottom: "1px solid black",
                    marginTop: 30,
                  }}
                />
                <div
                  style={{
                    marginTop: 15,
                    marginBottom: 25,
                    fontWeight: "bold",
                  }}
                >
                  {payslip?.employeeName}
                </div>
              </td>
            </tr>
            <tr>
              <td className="header-text-Italic">Acknowledgment of Staff:</td>
            </tr>
            <tr>
              <td className="text-grey" style={{ fontWeight: "normal" }}>
                I hereby acknowledge the receipt of the total net pay of{" "}
                <strong style={{ color: "black" }}>
                  US {Util.getInstance().formatCurrency(payslip.netPay)}
                </strong>{" "}
                which got deposited to my ABA bank account, as stated above. If
                I come across any error in this pays lip, instantly contact HRD
                unit.
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="footer">
        <div className="section-footer">
          <ul className="sec-1">
            <li>
              Phnom Penh Office #4, St. 278, Sangkat Olympic, P.O.Box 2228,Phnom
              Penh, Cambodia.
            </li>
            <li>
              Phone : <span>855-23 210 383, 855-23 218 197</span>
            </li>
            <li>
              Mobile : <span>855-12 800 103, 855-12 817 217</span>
            </li>
          </ul>
          <ul className="sec-2">
            <li>
              Phnom Penh Office #4, St. 278, Sangkat Olympic, P.O.Box 2228,Phnom
              Penh, Cambodia.
            </li>
            <li>
              Phone : <span>855-23 210 383, 855-23 218 197</span>
            </li>
            <li>
              Mobile : <span>855-12 800 103, 855-12 817 217</span>
            </li>
          </ul>
          <ul className="sec-3">
            <li>
              Phnom Penh Office #4, St. 278, Sangkat Olympic, P.O.Box 2228,Phnom
              Penh, Cambodia.
            </li>
            <li>
              Phone : <span>855-23 210 383, 855-23 218 197</span>
            </li>
            <li>
              Mobile : <span>855-12 800 103, 855-12 817 217</span>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}

export default ViewPayslip;
